// דירקטיבה שמאזינה לאירוע keyup, וכאשר האורך מגיע למקסימום – מעבירה לפוקוס הבא, רק אם הוקלד תו
import {
  Directive,
  HostListener,
  ElementRef,
} from '@angular/core';

@Directive({
  selector: 'input[maxlength], textarea[maxlength]', // מופעל על כל input עם maxlength
})
export class MoveNextByMaxLengthDirective {
  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;

    // רק אם הוקלד תו (ולא Tab/Shift/Arrow וכו') - קוד תווים רגילים מתחילים מ־48 ומעלה
    const isCharacterKey =
      event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;

    if (!target || !isCharacterKey || target.value.length < target.maxLength) return;

    // מונע הקשת תווים נוספים
    event.preventDefault();

    // מקבל את כל האלמנטים הפוקוסבילים בעמוד
    const allFocusable = Array.from(
      document.querySelectorAll<HTMLElement>(
        'input, textarea, select, button, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    );

    // מחפש את האלמנט הנוכחי ברשימה
    const currentIndex = allFocusable.indexOf(this.el.nativeElement);
    if (currentIndex >= 0 && currentIndex + 1 < allFocusable.length) {
      const next = allFocusable[currentIndex + 1];
      next.focus();
    }
  }
}